import { getWorkspace } from "@/utils/storage/appSession";

/**
 * Resolves an API route template by replacing `:param` placeholders.
 *
 * @param {string} route - Route template containing `:param` placeholders.
 * @param {APIRouteParams} params - Values used to replace route params.
 * @param {string[]} skipURIEncode - Params which should not be URLEncoded, like drivetype/Project
 * @returns {string} Concrete route string.
 */
export const buildApiRoute = <T extends APIRouteParams>(
  route: string,
  params?: T,
  skipURIEncode?: (keyof T)[],
): string => {
  const routeWithWorkspace: APIRouteParams = route.includes(":workspace")
    ? { workspace: getWorkspace(), ...(params ?? {}) }
    : (params ?? {});

  return route.replace(/:([a-zA-Z0-9_]+)/g, (_match, key: string) => {
    const rawValue = String(routeWithWorkspace[key] ?? "");
    if (skipURIEncode && skipURIEncode.includes(key)) {
      return rawValue;
    } else {
      return encodeURIComponent(rawValue);
    }
  });
};
